module.exports = __webpack_public_path__ + "static/img/1.f34c2f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/1.png
// module id = AR0w
// module chunks = 13